"use client";

import { Col as DSCol, Grid, type ColProps } from "@pamperedchef/design-system";
import { type FC, type ReactNode } from "react";
import { PlpProductCard } from "./PlpProductCard";

const Col = DSCol as FC<ColProps & { children?: ReactNode }>;

export interface PlpProductGridProps {
	/** Number of placeholder cards to render. */
	count?: number;
}

/** STUB results grid — DS `Grid`/`Col` laying out product-card placeholders. */
export function PlpProductGrid({
	count = 9
}: PlpProductGridProps): JSX.Element {
	return (
		<Grid columns={12} gap="lg">
			{Array.from({ length: count }, (_, i) => (
				<Col key={i} size={12} sm={6} md={4}>
					<PlpProductCard />
				</Col>
			))}
		</Grid>
	);
}
